import { createEffect, createEvent, createStore } from "effector";
import { ShopConfig, ShopPosition, voidShopConfig } from '../../../types/alice-bob';
import { $playerProfile, fetchMe } from "./playerProfile";
import { convertGems } from "../api/api";

export const purchase = createEvent<ShopPosition>();
$playerProfile.on(purchase, (state, purchase) => {
    if (!state) return;
    for (const item of purchase.items) state.player_wallet.currency_hard += item.amount
    return { ...state }
})
export const $shop = createStore<ShopConfig>(voidShopConfig)
    .on(fetchMe.doneData, (_, newState) => newState.shop)

export const convertGemsEffect = createEffect(async (offerId: string) => {
    return await convertGems(offerId);
});
$playerProfile.on(convertGemsEffect.doneData, (_, payload) => {
    return payload.player
})